module.exports = __webpack_public_path__ + "img/icon_home_ti.f2e496f3.png";